const checkPermissions = (userDetails, item) => {
  // console.log(userDetails);

  const found = userDetails?.permissions?.some((permission) =>
    item?.accessedByKey?.includes(permission)
  );
  return found;
};
export default checkPermissions;
